// extracted by mini-css-extract-plugin
module.exports = {"root":"intro-section-module--root--MCDsH","title":"intro-section-module--title--2qVHt","text":"intro-section-module--text--25Clz"};